import { IUseContentPagePreviewProps } from 'components/Pages/Admin/shared/ItinerariesItemLanding/types';
import { isDefined } from 'utils/ramda';

import { getHandledPageName } from '../../../utils';
import * as types from './../../types';

type Props = types.AboutUsFormValues | (IUseContentPagePreviewProps & types.AboutUsFormValues);

export const handleFormValues = (formValues: Props) => {
  const handle = getHandledPageName(formValues);
  const emergencyContacts = isDefined(formValues.emergencyContact) ? [formValues.emergencyContact] : [];

  const res = { ...formValues, emergencyContacts, handle };

  return res;
};
